import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useState } from "react";
import { addManufacturer } from "../../services/manufacturers";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import config from "../../config";

function AddManufacturer() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    criteriaMode: "all",
  });

  const addManufacturerMutation = useMutation({
    mutationFn: addManufacturer,
    onError(error) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
    onSuccess(data) {
      enqueueSnackbar("Add Manufacturer success!", { variant: "success" });
      navigate(config.routes.manufacturer);
    },
  });

  const handleSubmitForm = (values) => {
    const addData = {
      manufacturer_name: values.manufacturer_name,
      order_num: values.order_num,
    };
    addManufacturerMutation.mutate(addData);
  };

  return (
    <div>
      <form
        style={{ maxWidth: "600px" }}
        onSubmit={handleSubmit(handleSubmitForm)}
      >
        <h3 className="text-center">Add Manufacturer</h3>
        <div className="form-group row p-1">
          <label htmlFor="manufacturer_name" className="col-sm-4 col-form-label">
            Manufacturer Name:
          </label>
          <div className="col-sm-12">
            <input
              className="form-control"
              id="manufacturer_name"
              name="manufacturer_name"
              type="text"
              required
              {...register("manufacturer_name")}
            />
          </div>
        </div>
        <div className="form-group row p-1">
          <label htmlFor="order_num" className="col-sm-4 col-form-label">
            Order Num:
          </label>
          <div className="col-sm-12">
            <input
              className="form-control"
              id="order_num"
              name="order_num"
              type="number"
              min={0}
              {...register("order_num")}
            />
          </div>
        </div>
        <div
          className="d-flex justify-content-center p-2"
          style={{ gap: "10px" }}
        >
          <button type="submit" className="btn btn-primary">
            {addManufacturerMutation.isLoading && (
              <span>
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                &nbsp;
              </span>
            )}
            Submit
          </button>
          <button
            type="button"
            className=" btn btn-danger"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddManufacturer;
